import React from "react";
import Head from "next/head";

import InsureshieldMain from "@/components/insureshield/insureshield-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const InsureShieldPage = () => {
  return (
    <>
      <Head>
        <title>{seoData.INSURESHIELD.title}</title>
        <SeoMetaData data={seoData.INSURESHIELD} />
      </Head>

      <InsureshieldMain />
    </>
  );
};

export default InsureShieldPage;
